const $window = $(window);
// const breakPoint = 767;
const breakPoint = 1199;

let resizeFlag = false;
let windowWidth = $window.width();
let windowHeight = $window.height();

let url = location.href;

//ローディング
const loading = () => {
  $(window).on('load' , function() {
    $("#loading").addClass("loaded");
  });
};

//ヘッダーの開閉
const headerToggle = () => {
  //toggle
  const $header = $('.st-Header');
  const $headerTrigger = $('.st-Header_Hamburger');
  $headerTrigger.each(function(){
    $(this).on('click', function(){
      $header.toggleClass('opened');
      // $headerNavi.slideToggle(300, 'swing');
      return false;
    });
  });
};

//ページTOP
const pageTop = () =>{
  const topBtn = $('.sw-PageTop');
  topBtn.css({visibility:'hidden',opacity: 0});
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      topBtn.css({visibility:'visible',opacity: 1});
    } else {
      topBtn.css({visibility:'hidden',opacity: 0});
    }
  });
  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 1000);
    return false;
  });
};

//外部ページからのアンカー
const externalAnchor = () => {
  $(window).on('load' , function() {

      const url = $(location).attr('href');
      if (url.indexOf("?id=") == -1) {
      }else {
        const url_sp = url.split("?id=");
        const hash = '#' + url_sp[url_sp.length - 1];
        const tgt = $(hash);
        let pos;
        if(windowWidth > breakPoint){
          if($('body').hasClass('character')){
            pos = tgt.offset().top - windowWidth * 0.046875;
          }else{
            pos = tgt.offset().top;
          }
        }else{
          pos = tgt.offset().top - windowWidth * 0.17578125;
        }
        $("html, body").animate({
          scrollTop: pos
        }, 1000, "swing");
      }
  });
}

//ページ内リンクのアニメーション
const anchorScroll = () => {
  const $anchor = $('a[href^=#]');
  $anchor.click(function () {
    const speed = 1000;
    const href = $(this).attr('href');
    const target = $(href == '#' || href == '' ? 'html' : href);
    let position = target.offset().top;
    if(windowWidth > breakPoint){
      position = target.offset().top;
    }else{
      position = target.offset().top - windowWidth * 0.17578125;
    }
    $('html, body').animate({
      scrollTop: position
    }, speed, 'swing');
    return false;
  });
};

// preload
const preload = () =>{
  $(window).on('load' , function() {
    $("body").removeClass("preload");
  });
};

// resizing
const resizing = () =>{
  var timer = 0;
  $(window).on('resize' , function() {
    $("body").addClass("resizing");
    if (timer > 0) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $("body").removeClass("resizing");
      console.log('window resized');
    }, 100);
  });
};

// アニメーション
const animationFire = () =>{
  $(".js-Animation").each(function(){

    var animationFlag = false;
    var $target = $(this);

    $(window).on('load scroll' , function() {
      setTimeout(function(){
        var winScroll = $(window).scrollTop();
        var winHeight = $(window).height();
        var scrollPositon = winScroll + winHeight;

        if($target.offset().top < scrollPositon) {
          if(!animationFlag) {

            animationFlag = true;

            $target.addClass("animated");

          }
        }
      },500);
    });
  });
};

//YouTubeのモーダル
const youtubeModal = () => {
  const $modal = $('.sw-Movie_Modal');
  const $content = $('.sw-Movie_Modal-Content');
  const $youtube = $('.js-Youtube');
  // open
  $youtube.on('click', function(){
    const dataID = $(this).attr('data-youtube');
    //iframe append
    $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/'+dataID+'?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
    // fadeIn
    $modal.stop().fadeIn(400);
    return false;
  });
  //close
  $('.sw-Movie_Modal-Overlay,.sw-Movie_Modal-Close').on('click', function(){
    $modal.stop().fadeOut(400, function(){
      $content.children('iframe').remove();
    });
  });
};

//ページ下部のキャラランダム表示
const bottomCharaRandom = () => {

  const target = document.getElementById('randamChara');
  const charaArray = ['kasumi','tae','rimi','saaya','arisa'];
  const charaLengrh = charaArray.length;
  const random = Math.floor(Math.random() * charaLengrh);
  const className = charaArray[random];

  target.classList.add(className);
}

//export
export { loading, headerToggle, pageTop, externalAnchor, anchorScroll, preload, resizing, animationFire, youtubeModal, bottomCharaRandom };


// WEBPACK FOOTER //
// module.js